// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.e5f9cf6a8',
  revision: 'e5f9cf6a8',
  branch: 'develop',
  date: 'Wed, 09 Sep 2026 15:43:04 GMT'
};